import { NftTopList } from "../../../components/NFT/NftTopList"

export const NftTop100Page = () => {
  return <NftTopList number={100} />
}